import { Box } from '@mui/material';
import { money, qty } from '../lib/format';
import { useShop } from '../shop/ShopProvider';

/** Money in the shop's currency, tabular; negative amounts in the error colour when `signed`. */
export function Money({
  value,
  signed,
  strong,
}: {
  value: string | number | null | undefined;
  signed?: boolean;
  strong?: boolean;
}) {
  const { format } = useShop();
  const n = Number(value);
  return (
    <Box
      component="span"
      className="tabular"
      sx={{
        whiteSpace: 'nowrap',
        fontWeight: strong ? 650 : undefined,
        color: signed && n < 0 ? 'error.main' : undefined,
      }}
    >
      {money(value, format)}
    </Box>
  );
}

export function Qty({ value, unit }: { value: string | number | null | undefined; unit?: string }) {
  const { format } = useShop();
  return (
    <Box component="span" className="tabular" sx={{ whiteSpace: 'nowrap' }}>
      {qty(value, format)}
      {unit ? ` ${unit}` : ''}
    </Box>
  );
}
